import { render, staticRenderFns } from "./BaseRemoteList.vue?vue&type=template&id=b333ba6a&scoped=true"
import script from "./BaseRemoteList.vue?vue&type=script&lang=js"
export * from "./BaseRemoteList.vue?vue&type=script&lang=js"
import style0 from "./BaseRemoteList.vue?vue&type=style&index=0&id=b333ba6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b333ba6a",
  null
  
)

export default component.exports